import React from 'react';
import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { useIsDemoMode } from '@/hooks/use-is-demo-mode';

/**
 * Persistent banner displayed on all authenticated screens when the current
 * user is a demo account. Returns null when not in demo mode so it is
 * completely transparent to regular users.
 */
export function DemoBanner() {
  const isDemo = useIsDemoMode();

  if (!isDemo) {
    return null;
  }

  return (
    <View
      testID="demo-banner"
      className="bg-amber-50 border-b border-amber-200 px-4 py-1.5 items-center"
      role="banner"
      accessibilityLabel="Demo mode banner"
    >
      <Text className="text-amber-700 text-xs font-medium">
        Demo mode — exploring with sample data
      </Text>
    </View>
  );
}
